<template>
  <div>
    <el-table
      ref="multipleTable"
      class="table-list"
      :data="dataList"
      @row-click="clickFn"
      @row-dblclick="dblclickFn"
      tooltip-effect="dark"
      style="width: 100%"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" ></el-table-column>
      <el-table-column label="用户名" prop="user"  header-align="center">
        <template slot-scope="scope">
          <span>{{scope.row.userName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="昵称"  header-align="center">
        <template slot-scope="scope">
          <span>{{scope.row.nickName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户名称" prop="depart" width="280" header-align="center">
        <template slot-scope="scope">
          <el-tag v-show="scope.row.depart">{{scope.row.depart}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="角色" prop="role"  header-align="center">
        <template slot-scope="scope">
          <span>{{scope.row.roleId}}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="user" header-align="center">
        <template slot-scope="scope">
          <el-tag :type="oStateType[scope.row.status]" v-if="scope.row.status !== null">{{oState[scope.row.status]}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>

const oState = {
  1: '启用',
  0: '停用'
};
const oStateType = {
  1: 'success',
  0: 'danger'
};
export default {
  name: 'list',
  props: {
    dataList: {
      type: Array
    }
  },
  data() {
    return {
      oState,
      oStateType
    };
  },
  methods: {
    handleSelectionChange(selectArrys) {
      this.dataList.forEach(item => {
        item.checked = false;
      });
      for (let i = 0; i < selectArrys.length; i++) {
        selectArrys[i].checked = true;
      }
    },
    clickFn(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    dblclickFn(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
      this.$emit('detail');
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
